export const LOGO_CDN_URL = 'https://cdn.payappka.pl/biller_logo/';
export const LOGO_SUFFIX = '_100-100.png';
